module.exports = __webpack_public_path__ + "static/img/home_sofa_c.51ee422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/home_sofa_c.png
// module id = 4XMc
// module chunks = 3